export default {
    'diagram4-3a2': {
        'diagram-task': 'Fill in the rough summary and the simplified summary',

        'fixed-answer1': 'Let’s not overlook early training in music',
        'fixed-answer2': 'More early focus on music training in childhood may aid learning in other areas',
        'pre-fill': 'More early focus on music',

        'fixed-answer3': '<u>Early</u> childhood teaching <u>focuses on</u> developing the <u>"left-brain" skills</u> - reading, writing, and ‘rithmatic ',
        'fixed-answer4': 'But active participation in <u>music stimulates</u> development in <u>those very areas</u>',
        'fixed-answer5': 'Early focus on music may be every bit as important educationally as reading or writing',
    }
};



// WEBPACK FOOTER //
// ./client/app/components/diagrams/3/3a2/diagram4/i18n/en.js